// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"c39450a8","569":"c5a0f0ee","679":"70dcc827","787":"cfe37ef7"}[chunkId] + ".chunk.js";
};